import type { JSX } from 'react';

interface EmptyStateProps {
  /** When false, omit copy that refers to the add button (view-only or disabled modal). */
  canAddPatterns?: boolean;
}

export function EmptyState({
  canAddPatterns = true,
}: EmptyStateProps): JSX.Element {
  return (
    <div className="text-center py-8 text-muted-foreground">
      <p className="text-sm">No rules configured yet.</p>
      {canAddPatterns ? (
        <p className="text-xs mt-1">
          Click the button below to add your first rule.
        </p>
      ) : (
        <p className="text-xs mt-1">There are no rules to display.</p>
      )}
    </div>
  );
}
